import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    baseUrl: 'https://api.rimik.ir',
    apiVersion: 1,
    globalTimer: 180,
    isTimer: false,
    toastData: [],
    appName: {
    },
    os: '',
    mobileMode: false,
    isTeacher: false,
  },
  mutations: {
    setIsTeacher(state, payload) {
      state.isTeacher = payload;
    },
    setAppName(state, payload) {
      state.appName = payload;
      state.baseUrl = payload.url;
    },
    setMobileMode(state, payload) {
      state.mobileMode = payload;
    },
    makeToast(state, payload) {
      const el = {};
      let tic = '';
      let tbg = '';
      const tid = Math.floor(Math.random() * (12000 - 2000 + 1) + 2000);
      const tmsg = payload.msg;
      const td = payload.duration;
      switch (payload.type) {
        case 'error': {
          tic = 'report';
          tbg = '#ae4422';
          break;
        }
        case 'warning': {
          tic = 'warning';
          tbg = '#de8422';
          break;
        }
        case 'success': {
          tic = 'done_all';
          tbg = '#42ae62';
          break;
        }
        case 'info': {
          tic = 'info';
          tbg = '#2244ae';
          break;
        }
        case 'catch': {
          tic = 'wifi_off';
          tbg = '#121212';
          break;
        }
        default:
          break;
      }
      el.id = tid;
      el.bg = tbg;
      el.ic = tic;
      el.msg = tmsg;
      el.duration = td;
      state.toastData.push(el);
      setTimeout(() => {
        let indx = -1;
        for (let i = 0; i < this.state.toastData.length; i += 1) {
          if (this.state.toastData[i].id === td) {
            // console.log(td, i);
            indx = i;
          }
        }
        this.state.toastData.splice(indx, 1);
        // console.log('tdd', this.state.toastData);
      }, td);
      // console.log(state.toastData);
    },
    timerDown(state) {
      state.globalTimer -= 1;
    },
    resetTimer(state) {
      state.globalTimer = 180;
    },
    zeroTimer(state) {
      state.globalTimer = 0;
    },
    TimerFalse(state) {
      state.isTimer = false;
    },
    TimerTrue(state) {
      state.isTimer = true;
    },
    setOs(state, payload) {
      state.os = payload;
      alert(payload);
    },
  },
  actions: {
  },
  modules: {
  },
});
